// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import iView from 'iview';
import App from './App'
// import VueSocketio from 'vue-socket.io'
import {
    router
} from './router/index';
import store from './store';

import Toast from './libs/toast/';
import Http from './libs/http';
// 引入vue-amap
import VueAMap from 'vue-amap';
// import 'iview/dist/styles/iview.css';
// 当前系统主题色调
import './assets/css/my-them.less';
// 商品管理富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import overFlow from '@/views/main-components/overflow'
import arease from '@/views/main-components/arease'
import areaseinput from '@/views/main-components/areaseinput'
import days from '@/views/main-components/days'
import Dwtable from '@/views/main-components/table/table.vue'
import Dwedittable from '@/views/main-components/table/editTable.vue'
import testRool from '@/views/main-components/table/tests.vue'
//rtc播放器
import flvjs from 'flvjs';
Vue.use(flvjs);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import IScrollView from 'vue-iscroll-view'
import IScroll from 'iscroll'

//rsa加密
import JsEncrypt from 'jsencrypt'
Vue.prototype.$jsEncrypt = JsEncrypt
import dataV from '@jiaminghi/data-view'
import {dealStatus,dealTime,dealTimeMinute} from './utils/formatter'
Vue.prototype.dealStatus = dealStatus
Vue.prototype.dealTime = dealTime
Vue.prototype.dealTimeMinute = dealTimeMinute;
Vue.use(dataV)
// 引入echarts
import echarts from '@/utils/echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(Toast);
Vue.use(Http);
Vue.use(iView);
Vue.use(VueAMap);
Vue.use(VueQuillEditor, /* { default global options } */ );
Vue.use(IScrollView, IScroll);
// Vue.use(VueSocketio, 'ws://10.255.0.70:10006');
Vue.component('overFlow', overFlow);
Vue.component('arease', arease);
Vue.component('areaseinput', areaseinput);
Vue.component('days', days);
Vue.component('Dwtable', Dwtable);
Vue.component('Dwedittable', Dwedittable);
Vue.component('testRool', testRool);
// 初始化vue-amap
// VueAMap.initAMapApiLoader({
//     // 高德的key
//     key: 'b460adf03a6d5552f3f3cd4c68cf57ff',
//     v: '1.4.6',
//     // 插件集合
//     plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MouseTool', 'RangingTool', 'AMap.Geocoder', 'AMap.AMapUI']
// });

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router: router,
    store: store,
    render: h => h(App),
    data: {
        currentPageName: ''
    }
});



// WEBPACK FOOTER //
// ./src/main.js